import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {computed, ref} from 'vue';
import { IonDatetime, IonSelect, IonButton, IonSelectOption, toastController, IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle } from "@ionic/vue";
import { useWorkplace } from "@/composables/workplace";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingForm',
  setup(__props) {

const { fetchAvailableWorkplaces, bookWorkplace, state } = useWorkplace();
const selectedDate = ref<string>('');
const selectedOption = ref<string>('');

const presentToast = async(message = 'Your booking has been confirmed.', color = 'success') => {
  const toast = await toastController.create({
    message: message,
    duration: 2000,
    position: 'bottom',
    color: color
  });
  await toast.present();
}

const onDateChange = (event: any) => {
  selectedOption.value = '';

  fetchAvailableWorkplaces(event.detail.value);
}

const handleBookWorkplaceClick = async () => {
  await bookWorkplace(selectedOption.value, selectedDate.value);

  if (state.error) {
    await presentToast('Workplace is already booked. Please choose another workplace or date.', 'danger');
    return;
  }

  await presentToast();
}

const availableWorkplaces = computed(() => state.data?.elements);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(IonCard), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonCardHeader), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCardSubtitle), null, {
              default: _withCtx(() => [
                _createTextVNode("Book a Workplace")
              ]),
              _: 1
            }),
            _createVNode(_unref(IonCardTitle), null, {
              default: _withCtx(() => [
                _createTextVNode("Choose a Date")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonDatetime), {
          presentation: "date",
          onIonChange: onDateChange,
          color: "warning",
          modelValue: selectedDate.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDate).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    (_unref(availableWorkplaces) && _unref(availableWorkplaces).length > 0)
      ? (_openBlock(), _createBlock(_unref(IonCard), { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonSelect), {
              interface: "action-sheet",
              "interface-options": { header: 'Available Workplaces' },
              placeholder: "Select a Workplace",
              fill: "outline",
              modelValue: selectedOption.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedOption).value = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).data.elements, (workplace) => {
                  return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                    key: workplace.id,
                    value: workplace.id
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(workplace.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_unref(IonButton), {
              disabled: !selectedOption.value,
              expand: "block",
              color: "warning",
              onClick: handleBookWorkplaceClick,
              fill: "clear"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Book Workplace")
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})